import React, { useEffect, useRef, useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';

const DeviceCourseSelect = ({
  courseGroups,
  isCourseLoading,
  selectedClass,
  selectClass,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (!selectRef.current?.contains(event.target)) setIsOpen(false);
    };

    document.addEventListener('pointerdown', handlePointerDown);
    return () => document.removeEventListener('pointerdown', handlePointerDown);
  }, []);

  const handleSelect = (classItem) => {
    selectClass(classItem);
    setIsOpen(false);
  };

  return (
    <div
      className={`mobile-lms-select-wrap${isOpen ? ' is-open' : ''}`}
      ref={selectRef}
    >
      <button
        type="button"
        className="mobile-lms-select-trigger"
        onClick={() => setIsOpen((open) => !open)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') setIsOpen(false);
          if (event.key === 'ArrowDown') setIsOpen(true);
        }}
        disabled={isCourseLoading}
        aria-label="수업 선택"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        <span>{selectedClass?.name || '수업을 선택하세요'}</span>
        <FiChevronDown aria-hidden="true" />
      </button>

      {isOpen && (
        <div className="mobile-lms-select-options" role="listbox" aria-label="수업 목록">
          {courseGroups.map((group) => (
            <div className="mobile-lms-select-group" role="group" aria-label={group.name} key={group.code}>
              <strong>{group.name}</strong>
              {group.classes.map((classItem) => {
                const isSelected = String(classItem.code) === String(selectedClass?.code);

                return (
                  <button
                    type="button"
                    className={isSelected ? 'is-selected' : ''}
                    role="option"
                    aria-selected={isSelected}
                    key={classItem.code}
                    onClick={() => handleSelect(classItem)}
                  >
                    {classItem.name}
                  </button>
                );
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DeviceCourseSelect;
